var HOProductCodes = ['Homeowners', 'homeowners', 'HomeownersLine_HOE', 'HOPHomeowners'];
var LOB_KEYS = {
    'MORTGAGEE': {
        'Homeowners': 'MORTGAGEE',
        'HOPHomeowners': 'ADDITIONALMORTGAGEE'
    }
};

export default {
    normaliseProductCode: function normaliseProductCode(productCode) {
        if (HOProductCodes.includes(productCode)) {
            return 'Homeowners';
        }
        return productCode;
    },
    getLobSpecificKeyValue: function getLobSpecificKeyValue(key, productCode) {
        if (LOB_KEYS[key] && LOB_KEYS[key][productCode]) {
            return LOB_KEYS[key][productCode];
        }
        return key;
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=endorsement-products&equals=Homeowners!./common/js/src/edge/endorsement/ho/HOProductCodeUtil.js
// module id = 440
// module chunks = 0